<script lang="ts" setup>
definePageMeta({ breadcrumb: 'Карта сайта' });

const siteStore = useSiteStore();

const sitemap = await siteStore.getSitemap();
</script>

<template>
  <section
    v-if="sitemap"
    class="sitemap"
  >
    <div class="flex flex-col gap-4">
      <BreadcrumbsBlock />

      <h1>{{ sitemap.title }}</h1>
    </div>

    <SitemapSection
      v-if="sitemap.categories"
      :section-data="sitemap.categories"
      type="categories"
    />

    <SitemapSection
      v-if="sitemap.brands"
      :section-data="sitemap.brands"
      type="brands"
    />

    <SitemapSection
      v-if="sitemap.blog"
      :section-data="sitemap.blog"
      type="blog"
    />

    <SitemapSection
      v-if="sitemap.simple_pages"
      :section-data="sitemap.simple_pages"
      type="simple_pages"
    />
  </section>
</template>

<style lang="scss" scoped>
.sitemap {
  gap: 36px;

  @include inner-content;
}
</style>
